export const homeclips = [

    {src: 'assets/video/training/DontBeCheated.mp4'},
    {src: 'assets/video/training/ArgueVSDebate.mp4'},   

];
